import { defineComponent as ft, ref as a, toRef as K, computed as T, watch as N, nextTick as ht, onMounted as vt, watchEffect as bt, h as l, Fragment as pt } from "vue";
import gt from "./ghl-ui.es1572.js";
import Q from "./ghl-ui.es855.js";
import mt from "./ghl-ui.es854.js";
import { useRtl as wt } from "./ghl-ui.es851.js";
import Ct from "./ghl-ui.es1179.js";
import { render as D } from "./ghl-ui.es985.js";
import { createKey as X } from "./ghl-ui.es384.js";
import { getMargin as Y } from "./ghl-ui.es856.js";
import { useThemeClass as xt } from "./ghl-ui.es857.js";
import { Wrapper as yt } from "./ghl-ui.es1548.js";
import It from "./ghl-ui.es1031.js";
import V from "./ghl-ui.es372.js";
import Z from "./ghl-ui.es1049.js";
import Pt from "./ghl-ui.es216.js";
import { getTitleAttribute as ee } from "./ghl-ui.es891.js";
import { useOnResize as Rt } from "./ghl-ui.es1149.js";
const Kt = ft({
  name: "InternalSelection",
  props: Object.assign(Object.assign({}, Q.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    active: Boolean,
    pattern: {
      type: String,
      default: ""
    },
    placeholder: String,
    selectedOption: {
      type: Object,
      default: null
    },
    selectedOptions: {
      type: Array,
      default: null
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    multiple: Boolean,
    filterable: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    loading: Boolean,
    autofocus: Boolean,
    showArrow: {
      type: Boolean,
      default: !0
    },
    inputProps: Object,
    focused: Boolean,
    renderTag: Function,
    onKeydown: Function,
    onClick: Function,
    onBlur: Function,
    onFocus: Function,
    onDeleteOption: Function,
    maxTagCount: [String, Number],
    ellipsisTagPopoverProps: Object,
    onClear: Function,
    onPatternInput: Function,
    onPatternFocus: Function,
    onPatternBlur: Function,
    renderLabel: Function,
    status: String,
    inlineThemeDisabled: Boolean,
    ignoreComposition: {
      type: Boolean,
      default: !0
    },
    onResize: Function
  }),
  setup(t) {
    const {
      mergedClsPrefixRef: _,
      mergedRtlRef: F
    } = mt(t), c = wt("InternalSelection", F, _), p = a(null), s = a(null), y = a(null), o = a(null), O = a(null), g = a(null), f = a(null), h = a(null), m = a(null), w = a(null), C = a(!1), u = a(!1), x = a(!1), v = Q("InternalSelection", "-internal-selection", gt, Ct, t, K(t, "clsPrefix")), d = T(() => t.clearable && !t.disabled && (x.value || t.active)), b = T(() => t.selectedOption ? t.renderTag ? t.renderTag({
      option: t.selectedOption,
      handleClose: () => {
      }
    }) : t.renderLabel ? t.renderLabel(t.selectedOption, !0) : D(t.selectedOption[t.labelField], t.selectedOption, !0) : t.placeholder), E = T(() => {
      const e = t.selectedOption;
      if (e)
        return e[t.labelField];
    }), I = T(() => t.multiple ? !!(Array.isArray(t.selectedOptions) && t.selectedOptions.length) : t.selectedOption !== null);
    function P() {
      var e;
      const {
        value: n
      } = p;
      if (n) {
        const {
          value: i
        } = s;
        i && (i.style.width = `${n.offsetWidth}px`, t.maxTagCount !== "responsive" && ((e = m.value) === null || e === void 0 || e.sync({
          showAllItemsBeforeCalculate: !1
        })));
      }
    }
    function S() {
      const {
        value: e
      } = w;
      e && (e.style.display = "none");
    }
    function A() {
      const {
        value: e
      } = w;
      e && (e.style.display = "inline-block");
    }
    N(K(t, "active"), (e) => {
      e || S();
    }), N(K(t, "pattern"), () => {
      t.multiple && ht(P);
    });
    function W(e) {
      const {
        onFocus: n
      } = t;
      n && n(e);
    }
    function U(e) {
      const {
        onBlur: n
      } = t;
      n && n(e);
    }
    function k(e) {
      const {
        onDeleteOption: n
      } = t;
      n && n(e);
    }
    function B(e) {
      const {
        onClear: n
      } = t;
      n && n(e);
    }
    function r(e) {
      const {
        onPatternInput: n
      } = t;
      n && n(e);
    }
    function te(e) {
      var n;
      (!e.relatedTarget || !(!((n = y.value) === null || n === void 0) && n.contains(e.relatedTarget))) && W(e);
    }
    function ne(e) {
      var n;
      !((n = y.value) === null || n === void 0) && n.contains(e.relatedTarget) || U(e);
    }
    function oe(e) {
      B(e);
    }
    function le() {
      x.value = !0;
    }
    function ie() {
      x.value = !1;
    }
    function re(e) {
      !t.active || !t.filterable || e.target !== s.value && e.preventDefault();
    }
    function q(e) {
      k(e);
    }
    function ae(e) {
      if (e.key === "Backspace" && !$.value && !t.pattern.length) {
        const {
          selectedOptions: n
        } = t;
        n != null && n.length && q(n[n.length - 1]);
      }
    }
    const $ = a(!1);
    let L = null;
    function se(e) {
      const {
        value: n
      } = p;
      if (n) {
        const i = e.target.value;
        n.textContent = i, P();
      }
      t.ignoreComposition && $.value ? L = e : r(e);
    }
    function ue() {
      $.value = !0;
    }
    function de() {
      $.value = !1, t.ignoreComposition && r(L), L = null;
    }
    function ce(e) {
      var n;
      u.value = !0, (n = t.onPatternFocus) === null || n === void 0 || n.call(t, e);
    }
    function fe(e) {
      var n;
      u.value = !1, (n = t.onPatternBlur) === null || n === void 0 || n.call(t, e);
    }
    function he() {
      var e, n;
      if (t.filterable)
        u.value = !1, (e = g.value) === null || e === void 0 || e.blur(), (n = s.value) === null || n === void 0 || n.blur();
      else if (t.multiple) {
        const {
          value: i
        } = o;
        i == null || i.blur();
      } else {
        const {
          value: i
        } = O;
        i == null || i.blur();
      }
    }
    function ve() {
      var e, n, i;
      t.filterable ? (u.value = !1, (e = g.value) === null || e === void 0 || e.focus()) : t.multiple ? (n = o.value) === null || n === void 0 || n.focus() : (i = O.value) === null || i === void 0 || i.focus();
    }
    function be() {
      const {
        value: e
      } = s;
      e && (A(), e.focus());
    }
    function pe() {
      const {
        value: e
      } = s;
      e && e.blur();
    }
    function ge(e) {
      const {
        value: n
      } = f;
      n && n.setTextContent(`+${e}`);
    }
    function me() {
      const {
        value: e
      } = h;
      return e;
    }
    function we() {
      return s.value;
    }
    let j = null;
    function H() {
      j !== null && window.clearTimeout(j);
    }
    function Ce() {
      t.active || (H(), j = window.setTimeout(() => {
        I.value && (C.value = !0);
      }, 100));
    }
    function xe() {
      H();
    }
    function ye(e) {
      e || (H(), C.value = !1);
    }
    N(I, (e) => {
      e || (C.value = !1);
    }), vt(() => {
      bt(() => {
        const e = g.value;
        e && (t.disabled ? e.removeAttribute("tabindex") : e.tabIndex = u.value ? -1 : 0);
      });
    }), Rt(y, t.onResize);
    const {
      inlineThemeDisabled: G
    } = t, J = T(() => {
      const {
        size: e
      } = t, {
        common: {
          cubicBezierEaseInOut: n
        },
        self: {
          borderRadius: i,
          color: Ie,
          placeholderColor: Pe,
          textColor: Re,
          paddingSingle: Te,
          paddingMultiple: Fe,
          caretColor: Oe,
          colorDisabled: $e,
          textColorDisabled: _e,
          placeholderColorDisabled: Ee,
          colorActive: Se,
          boxShadowFocus: Be,
          boxShadowActive: Me,
          boxShadowHover: ze,
          border: De,
          borderFocus: Ae,
          borderHover: We,
          borderActive: ke,
          arrowColor: Le,
          arrowColorDisabled: je,
          loadingColor: He,
          // form warning
          colorActiveWarning: Ke,
          boxShadowFocusWarning: Ne,
          boxShadowActiveWarning: Ve,
          boxShadowHoverWarning: Ue,
          borderWarning: qe,
          borderFocusWarning: Ge,
          borderHoverWarning: Je,
          borderActiveWarning: Qe,
          // form error
          colorActiveError: Xe,
          boxShadowFocusError: Ye,
          boxShadowActiveError: Ze,
          boxShadowHoverError: et,
          borderError: tt,
          borderFocusError: nt,
          borderHoverError: ot,
          borderActiveError: lt,
          // clear
          clearColor: it,
          clearColorHover: rt,
          clearColorPressed: at,
          clearSize: st,
          // arrow
          arrowSize: ut,
          [X("height", e)]: dt,
          [X("fontSize", e)]: ct
        }
      } = v.value, M = Y(Te), z = Y(Fe);
      return {
        "--n-bezier": n,
        "--n-border": De,
        "--n-border-active": ke,
        "--n-border-focus": Ae,
        "--n-border-hover": We,
        "--n-border-radius": i,
        "--n-box-shadow-active": Me,
        "--n-box-shadow-focus": Be,
        "--n-box-shadow-hover": ze,
        "--n-caret-color": Oe,
        "--n-color": Ie,
        "--n-color-active": Se,
        "--n-color-disabled": $e,
        "--n-font-size": ct,
        "--n-height": dt,
        "--n-padding-single-top": M.top,
        "--n-padding-multiple-top": z.top,
        "--n-padding-single-right": M.right,
        "--n-padding-multiple-right": z.right,
        "--n-padding-single-left": M.left,
        "--n-padding-multiple-left": z.left,
        "--n-padding-single-bottom": M.bottom,
        "--n-padding-multiple-bottom": z.bottom,
        "--n-placeholder-color": Pe,
        "--n-placeholder-color-disabled": Ee,
        "--n-text-color": Re,
        "--n-text-color-disabled": _e,
        "--n-arrow-color": Le,
        "--n-arrow-color-disabled": je,
        "--n-loading-color": He,
        // form warning
        "--n-color-active-warning": Ke,
        "--n-box-shadow-focus-warning": Ne,
        "--n-box-shadow-active-warning": Ve,
        "--n-box-shadow-hover-warning": Ue,
        "--n-border-warning": qe,
        "--n-border-focus-warning": Ge,
        "--n-border-hover-warning": Je,
        "--n-border-active-warning": Qe,
        // form error
        "--n-color-active-error": Xe,
        "--n-box-shadow-focus-error": Ye,
        "--n-box-shadow-active-error": Ze,
        "--n-box-shadow-hover-error": et,
        "--n-border-error": tt,
        "--n-border-focus-error": nt,
        "--n-border-hover-error": ot,
        "--n-border-active-error": lt,
        // clear
        "--n-clear-size": st,
        "--n-clear-color": it,
        "--n-clear-color-hover": rt,
        "--n-clear-color-pressed": at,
        // arrow-size
        "--n-arrow-size": ut
      };
    }), R = G ? xt("internal-selection", T(() => t.size[0]), J, t) : void 0;
    return {
      mergedTheme: v,
      mergedClearable: d,
      mergedClsPrefix: _,
      rtlEnabled: c,
      patternInputFocused: u,
      filterablePlaceholder: b,
      label: E,
      selected: I,
      showTagsPanel: C,
      isComposing: $,
      // dom ref
      counterRef: f,
      counterWrapperRef: h,
      patternInputMirrorRef: p,
      patternInputRef: s,
      selfRef: y,
      multipleElRef: o,
      singleElRef: O,
      patternInputWrapperRef: g,
      overflowRef: m,
      inputTagElRef: w,
      handleMouseDown: re,
      handleFocusin: te,
      handleClear: oe,
      handleMouseEnter: le,
      handleMouseLeave: ie,
      handleDeleteOption: q,
      handlePatternKeyDown: ae,
      handlePatternInputInput: se,
      handlePatternInputBlur: fe,
      handlePatternInputFocus: ce,
      handleMouseEnterCounter: Ce,
      handleMouseLeaveCounter: xe,
      handleFocusout: ne,
      handleCompositionEnd: de,
      handleCompositionStart: ue,
      onPopoverUpdateShow: ye,
      focus: ve,
      focusInput: be,
      blur: he,
      blurInput: pe,
      updateCounter: ge,
      getCounter: me,
      getTail: we,
      renderLabel: t.renderLabel,
      cssVars: G ? void 0 : J,
      themeClass: R == null ? void 0 : R.themeClass,
      onRender: R == null ? void 0 : R.onRender
    };
  },
  render() {
    const {
      status: t,
      multiple: _,
      size: F,
      disabled: c,
      filterable: p,
      maxTagCount: s,
      bordered: y,
      clsPrefix: o,
      ellipsisTagPopoverProps: O,
      onRender: g,
      renderTag: f,
      renderLabel: h
    } = this;
    g == null || g();
    const m = s === "responsive", w = typeof s == "number", C = m || w, u = l(yt, null, {
      default: () => l(It, {
        clsPrefix: o,
        loading: this.loading,
        showArrow: this.showArrow,
        showClear: this.mergedClearable && this.selected,
        onClear: this.handleClear
      }, {
        default: () => {
          var v, d;
          return (d = (v = this.$slots).arrow) === null || d === void 0 ? void 0 : d.call(v);
        }
      })
    });
    let x;
    if (_) {
      const {
        labelField: v
      } = this, d = (r) => l("div", {
        class: `${o}-base-selection-tag-wrapper`,
        key: r.value
      }, f ? f({
        option: r,
        handleClose: () => {
          this.handleDeleteOption(r);
        }
      }) : l(V, {
        size: F,
        closable: !r.disabled,
        disabled: c,
        onClose: () => {
          this.handleDeleteOption(r);
        },
        internalCloseIsButtonTag: !1,
        internalCloseFocusable: !1
      }, {
        default: () => h ? h(r, !0) : D(r[v], r, !0)
      })), b = () => (w ? this.selectedOptions.slice(0, s) : this.selectedOptions).map(d), E = p ? l("div", {
        class: `${o}-base-selection-input-tag`,
        ref: "inputTagElRef",
        key: "__input-tag__"
      }, l("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        tabindex: -1,
        disabled: c,
        value: this.pattern,
        autofocus: this.autofocus,
        class: `${o}-base-selection-input-tag__input`,
        onBlur: this.handlePatternInputBlur,
        onFocus: this.handlePatternInputFocus,
        onKeydown: this.handlePatternKeyDown,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), l("span", {
        ref: "patternInputMirrorRef",
        class: `${o}-base-selection-input-tag__mirror`
      }, this.pattern)) : null, I = m ? () => l("div", {
        class: `${o}-base-selection-tag-wrapper`,
        ref: "counterWrapperRef"
      }, l(V, {
        size: F,
        ref: "counterRef",
        onMouseenter: this.handleMouseEnterCounter,
        onMouseleave: this.handleMouseLeaveCounter,
        disabled: c
      })) : void 0;
      let P;
      if (w) {
        const r = this.selectedOptions.length - s;
        r > 0 && (P = l("div", {
          class: `${o}-base-selection-tag-wrapper`,
          key: "__counter__"
        }, l(V, {
          size: F,
          ref: "counterRef",
          onMouseenter: this.handleMouseEnterCounter,
          disabled: c
        }, {
          default: () => `+${r}`
        })));
      }
      const S = m ? p ? l(Z, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        getTail: this.getTail,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: b,
        counter: I,
        tail: () => E
      }) : l(Z, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: b,
        counter: I
      }) : w && P ? b().concat(P) : b(), A = C ? () => l("div", {
        class: `${o}-base-selection-popover`
      }, m ? b() : this.selectedOptions.map(d)) : void 0, W = C ? Object.assign({
        show: this.showTagsPanel,
        trigger: "hover",
        overlap: !0,
        placement: "top",
        width: "trigger",
        onUpdateShow: this.onPopoverUpdateShow,
        theme: this.mergedTheme.peers.Popover,
        themeOverrides: this.mergedTheme.peerOverrides.Popover
      }, O) : null, k = (this.selected ? !1 : this.active ? !this.pattern && !this.isComposing : !0) ? l("div", {
        class: `${o}-base-selection-placeholder ${o}-base-selection-overlay`
      }, l("div", {
        class: `${o}-base-selection-placeholder__inner`
      }, this.placeholder)) : null, B = p ? l("div", {
        ref: "patternInputWrapperRef",
        class: `${o}-base-selection-tags`
      }, S, m ? null : E, u) : l("div", {
        ref: "multipleElRef",
        class: `${o}-base-selection-tags`,
        tabindex: c ? void 0 : 0
      }, S, u);
      x = l(pt, null, C ? l(Pt, Object.assign({}, W, {
        scrollable: !0,
        style: "max-height: calc(var(--v-target-height) * 6.6);"
      }), {
        trigger: () => B,
        default: A
      }) : B, k);
    } else if (p) {
      const v = this.pattern || this.isComposing, d = this.active ? !v : !this.selected, b = this.active ? !1 : this.selected;
      x = l("div", {
        ref: "patternInputWrapperRef",
        class: `${o}-base-selection-label`,
        title: this.patternInputFocused ? void 0 : ee(this.label)
      }, l("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        class: `${o}-base-selection-input`,
        value: this.active ? this.pattern : "",
        placeholder: "",
        readonly: c,
        disabled: c,
        tabindex: -1,
        autofocus: this.autofocus,
        onFocus: this.handlePatternInputFocus,
        onBlur: this.handlePatternInputBlur,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), b ? l("div", {
        class: `${o}-base-selection-label__render-label ${o}-base-selection-overlay`,
        key: "input"
      }, l("div", {
        class: `${o}-base-selection-overlay__wrapper`
      }, f ? f({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : h ? h(this.selectedOption, !0) : D(this.label, this.selectedOption, !0))) : null, d ? l("div", {
        class: `${o}-base-selection-placeholder ${o}-base-selection-overlay`,
        key: "placeholder"
      }, l("div", {
        class: `${o}-base-selection-overlay__wrapper`
      }, this.filterablePlaceholder)) : null, u);
    } else
      x = l("div", {
        ref: "singleElRef",
        class: `${o}-base-selection-label`,
        tabindex: this.disabled ? void 0 : 0
      }, this.label !== void 0 ? l("div", {
        class: `${o}-base-selection-input`,
        title: ee(this.label),
        key: "input"
      }, l("div", {
        class: `${o}-base-selection-input__content`
      }, f ? f({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : h ? h(this.selectedOption, !0) : D(this.label, this.selectedOption, !0))) : l("div", {
        class: `${o}-base-selection-placeholder ${o}-base-selection-overlay`,
        key: "placeholder"
      }, l("div", {
        class: `${o}-base-selection-placeholder__inner`
      }, this.placeholder)), u);
    return l("div", {
      ref: "selfRef",
      class: [`${o}-base-selection`, this.rtlEnabled && `${o}-base-selection--rtl`, this.themeClass, t && `${o}-base-selection--${t}-status`, {
        [`${o}-base-selection--active`]: this.active,
        [`${o}-base-selection--selected`]: this.selected || this.active && this.pattern,
        [`${o}-base-selection--disabled`]: this.disabled,
        [`${o}-base-selection--multiple`]: this.multiple,
        // focus is not controlled by selection itself since it always need
        // to be managed together with menu. provide :focus style will cause
        // many redundant codes.
        [`${o}-base-selection--focus`]: this.focused
      }],
      style: this.cssVars,
      onClick: this.onClick,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onKeydown: this.onKeydown,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onMousedown: this.handleMouseDown
    }, x, y ? l("div", {
      class: `${o}-base-selection__border`
    }) : null, y ? l("div", {
      class: `${o}-base-selection__state-border`
    }) : null);
  }
});
export {
  Kt as default
};
